import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { useAlert } from 'react-alert'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import {
  updateCurrentDate,
  updateTaskAnnounce,
  updateTaskLabelingBaseWorkTimeView,
  updateTaskLabelingGuide,
  updateTaskLabelingSortType,
} from '../../../../states/containers/common/currentSlice'
import { RootState } from '../../../../states/containers/store'
import {
  changeTaskLabelingStatus,
  createTaskApprovalApplication,
  createTaskExcludeAutoLabelingTask,
  createTaskLabeling,
  createTaskManual,
  createTaskSeparate,
  destroyTaskExcludeAutoLabelingTask,
  destroyTaskLabeling,
  destroyTaskManual,
  destroyTaskSeparate,
  fetchTaskApprovalApplicationDetail,
  fetchTaskLabeling,
  fetchTaskNotWorkingRange,
  updateTaskLabeling,
  updateTaskNotWorkingRange,
} from '../../../../states/containers/task/taskSlice'
import { LangValue } from '../../../../states/types/common'
import {
  buildWorkTime,
  dateManipulateDay,
  dateToTodayElapsedSeconds,
  format,
  nowDate,
  secToHour,
  secToHourMinute,
  secToMinute,
  secToSec,
  secToTwoDigitsSec,
} from '../../../../utils/date'
import { isManager } from '../../../../utils/role'
import { getGetPrams, setPath } from '../../../../utils/url'
import LoadingSquare from '../../../components/common/LoadingSquare'
import Tips from '../../../components/common/Tips'
import DateCalendarModule from '../../../components/task/DateCalendarModule'
import LabelingModule from '../../../components/task/LabelingModule'
import PersistenceConfirmationModal from '../../../components/task/PersistenceConfirmationModal'
import SvgPieChart from '../../../components/task/SvgPieChart'
import UseLabelModal from '../../../components/task/UseLabelModal'
import { URL } from '../../../constants/url'
import { sortBy, uniqueId } from 'lodash'
import CutTaskModal from '../../../components/task/CutTaskModal'
import { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types'
import VideoGuide from '../../../components/common/VideoGuide'
import { labelColor, statusText } from '../../../../utils/taskStatusLabel'
import ApprovedModal from '../../../components/task/ApprovedModal'
import ExclusionAutoLabelingConfirmationModal from '../../../components/task/ExclusionAutoLabelingConfirmationModal'
import AddLabelBigModal from '../../../components/task/AddLabelBigModal'
import NotWorkingModal from '../../../components/task/NotWorkingModal'
import NotWorkingModalForDisplay from '../../../components/task/NotWorkingModalForDisplay'
import Modal from '../../../components/common/Modal'

interface GetParams {
  date: string
}

interface ConfirmationModalState {
  display: boolean
  taskId: number
  labelId: number
  labelGroupId: number
  callback: (taskId: number, labelGroupId: number, labelId: number, persistence: boolean) => void
}

interface AddTask {
  member_id: number
  date: string
  name: string | null
  timeline: {
    start_time: string
    end_time: string
  }[]
  label_id?: number
}

interface CutTask {
  origin_task_id: number
  start_time: string
  end_time: string
  name: string | null
  label_id?: number
}

interface GraphItem {
  name: string
  color: string
  value: number
}
interface TaskCategorize {
  label_groups : GraphItem[]
  labels : GraphItem[]
}

interface TaskDetail {
  task_id: number
  type: string
  origin_task_id: number | null
  time: number
  service_name: string | null
  icon: string | null
  icon_color: string | null
  task_name: string | null
  file_path: string | null
  included_url_parts: string | null
  url: string | null
  exclusion_id: number | null
  timeline: {
    start_time: string
    end_time: string
  }[]
  label: {
    label_group_id: number
    label_group_name: string
    label_group_color: string
    label_group_code: string | null
    label_id: number
    label_name: string
    label_color: string
    label_code: string | null
    disabled: boolean
    status: string
  } | null
  is_loading?: boolean
}

interface DetailParam {
  member_id: number
  member_name: string
  target_date: string
}

interface UpdateParam {
  member_id: number
  status: string
  comment: string
  target_date: string
  work_start_time?: string
  work_end_time?: string
}

interface FormatOther {
  start_sec: number;
  end_sec: number;
  service_name: string;
  icon: string | null;
  icon_color: string | null;
  start_time: string;
  end_time: string;
}

interface LabelCommon {
  id: number
  name: string
  code: string | null
  color: string
}

const Index: FC = () => {
  const { id } = useParams<{ id: string }>()
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const alert = useAlert()
  const { language } = useParams<{ language: LangValue }>()

  const {
    task,
    commonPart,
    login,
    current,
  } = useSelector((state: RootState) => state)

  const RESERVED_LABEL_GROUP_ID = 2

  const TIME_LIST = Array(25).fill(null).map((_v, i) => `${i + 5}:00`)

  const [date, setDate] = useState<string>("")
  const [isDisplayUseLabel, setIsDisplayUseLabel] = useState<boolean>(false)
  const [selectTask, setSelectTask] = useState<{ ids: number[], x: number, y: number, isFixed?: boolean }>()
  const [wait, setWait] = useState<boolean>(false)

  const [addTaskIds, setAddTaskIds] = useState<number[]>([])

  const [confirmationModalState, setConfirmationModalState] = useState<ConfirmationModalState>({
    display: false,
    taskId: 0,
    labelId: 0,
    labelGroupId: 0,
    callback: () => {
      // none
    },
  })

  const [targetTaskIds, setTargetTaskIds] = useState<number[]>([])
  const [holdText, setHoldText] = useState<string>("")

  const [isDisplayPanel, setIsDisplayPanel] = useState<boolean>(true)

  const [taskCategorize, setTaskCategorize] = useState<TaskCategorize>({ label_groups: [], labels: [] })

  const [taskList, setTaskList] = useState<TaskDetail[]>([])
  const [sortType, setSortType] = useState<string>("measure")

  const [cutTaskOrigin, setCutTaskOrigin] = useState<TaskDetail>()
  const [isDisplayCutModal, setIsDisplayCutModal] = useState<boolean>(false)

  const [exclusionTask, setExclusionTask] = useState<TaskDetail>()
  const [isDisplayExclusionModal, setIsDisplayExclusionModal] = useState<boolean>(false)

  const [type, setType] = useState<string>("")

  const [checkedTaskIds, setCheckedTaskIds] = useState<number[]>([])

  const [isOpenDetailModal, setIsOpenDetailModal] = useState<boolean>(false)
  const [detailData, setDetailData] = useState<DetailParam>({
    member_id: 0,
    member_name: "",
    target_date: "",
  })

  const [tmpTaskIds, setTmpTaskIds] = useState<number[]>([])

  const [selectPeriod, setSelectPeriod] = useState<number[]>([])
  const [dragPeriod, setDragPeriod] = useState<boolean>(false)
  const [selectPeriodTaskIds, setSelectPeriodTargetTaskIds] = useState<number[]>([])

  const [untrackedTask, setUntrackedTask] = useState<{ start_time: string, end_time: string, start_sec: number, end_sec: number }[]>([])

  const [isOpenNotWorkingModal, setIsOpenNotWorkingModal] = useState<boolean>(false)
  const [isLoadingNotWorkingModal, setIsLoadingNotWorkingModal] = useState<boolean>(false)
  const [fetchTrigger, setFetchTrigger] = useState<boolean>(false)

  const [isLabeledInNotWorkingRange, setIsLabeledInNotWorkingRange] = useState<boolean>(false)
  const [isDisplayBaseWorkTime, setIsDisplayBaseWorkTime] = useState<boolean>(true)

  const [isLoadingManualTask, setIsLoadingManualTask] = useState<boolean>(false)

  const [isOpenLabelingGuide, setIsOpenLabelingGuide] = useState<boolean>(false)

  const periodList = useMemo(() => {
    if (!selectPeriod || selectPeriod.length === 0) {
      return []
    }

    const tmpList = selectPeriod.reduce((result: number[][], number, index) => {
      if (index === 0) {
        result.push([number])
        return result
      }
      const lastGroup = result[result.length - 1]
      const lastNumber = lastGroup[lastGroup.length - 1]
      if (number === lastNumber + 1) {
        lastGroup.push(number)
      } else {
        result.push([number])
      }
      return result
    }, [])

    return tmpList.map((v) => (
      {
        startSec: (v[0] * 1800) + 18000,
        endSec: ((v[v.length - 1] * 1800) + 18000 + 1800),
      }
    ))
  }, [selectPeriod])

  const selectRecodeList = useMemo(() => {
    if (!untrackedTask) return []
    const tmpList: { startTime: number, endTime: number }[] = []
    const tmpTargetTaskIds: number[] = []
    periodList.forEach((period) => {
      untrackedTask.filter((v) => (v.end_sec - v.start_sec) > 0).forEach((v) => {
        if (!(period.startSec < v.end_sec && v.start_sec < period.endSec)) return
        tmpList.push({
          startTime: period.startSec < v.start_sec ? v.start_sec : period.startSec,
          endTime: v.end_sec < period.endSec ? v.end_sec : period.endSec,
        })
      })
      const tmp = taskList?.filter((v) => v.timeline.map((w) => ({
        ...v, start_sec: dateToTodayElapsedSeconds(w.start_time, date), end_sec: dateToTodayElapsedSeconds(w.end_time, date),
      })).filter((w) => (
        (w.start_sec >= period.startSec && w.end_sec <= period.endSec)
        || (w.start_sec < period.startSec && w.end_sec >= period.startSec && w.end_sec <= period.endSec)
        || (w.end_sec > period.endSec && w.start_sec >= period.startSec && w.start_sec <= period.endSec)
      )).length).map((v) => v.task_id) || []
      tmpTargetTaskIds.push(...tmp)
    })
    setSelectPeriodTargetTaskIds(Array.from(new Set(tmpTargetTaskIds)))
    return tmpList
  }, [periodList, untrackedTask])

  const inRecodeTotalTime = useMemo(() => {
    if (!selectRecodeList.length) return 0
    return selectRecodeList.reduce((s, v) => s + (v.endTime - v.startTime), 0)
  }, [selectRecodeList])

  const originTask = useMemo(() => {
    if (!task.taskLabeling?.tasks) return []
    // eslint-disable-next-line max-len
    return task.taskLabeling?.tasks.map((v) => ({ ...v, timeline: v.timeline.map((w) => ({ ...w, start_sec: dateToTodayElapsedSeconds(w.start_time, date), end_sec: dateToTodayElapsedSeconds(w.end_time, date) })) }))
  }, [task.taskLabeling?.tasks])

  const buildTime = (sec: number) => {
    if (sec < 86400) {
      return `${date} ${buildWorkTime(sec)}`
    }
    return `${dateManipulateDay(date, 1, "YYYY-MM-DD")} ${buildWorkTime(sec - 86400)}`
  }

  const formatTaskList = useMemo(() => {
    const inRangeLabeled: boolean[] = []
    // eslint-disable-next-line max-len
    const cutTimeList = task.taskLabeling?.not_working_ranges.map((v) => ({ ...v, start_sec: dateToTodayElapsedSeconds(v.start_time, date), end_sec: dateToTodayElapsedSeconds(v.end_time, date) })) || []
    return originTask.map((data) => {
      const tmpTimeline = data.timeline.map((timeData) => {
        let tmpDataList = [timeData]
        cutTimeList.forEach((range) => {
          tmpDataList.forEach((tmpTimeData) => {
            if (range.start_sec <= tmpTimeData.start_sec && range.end_sec > tmpTimeData.start_sec && range.end_sec <= tmpTimeData.end_sec) {
              tmpDataList = [{ ...tmpTimeData, start_sec: range.end_sec, start_time: buildTime(range.end_sec) }]
              inRangeLabeled.push(!!data.label)
            } else if (range.start_sec >= tmpTimeData.start_sec && range.start_sec < tmpTimeData.end_sec && range.end_sec >= tmpTimeData.end_sec) {
              tmpDataList = [{ ...tmpTimeData, end_sec: range.start_sec, end_time: buildTime(range.start_sec) }]
              inRangeLabeled.push(!!data.label)
            } else if (range.start_sec >= tmpTimeData.start_sec && range.end_sec <= tmpTimeData.end_sec) {
              tmpDataList = [
                { ...tmpTimeData, end_sec: range.start_sec, end_time: buildTime(range.start_sec) },
                { ...tmpTimeData, start_sec: range.end_sec, start_time: buildTime(range.end_sec) },
              ]
              inRangeLabeled.push(!!data.label)
            } else if (range.start_sec <= tmpTimeData.start_sec && range.end_sec >= tmpTimeData.end_sec) {
              tmpDataList = []
              inRangeLabeled.push(!!data.label)
            }
          })
        })
        return tmpDataList
      }).flat()
      setIsLabeledInNotWorkingRange(inRangeLabeled.some((v) => v))
      return (
        {
          ...data,
          timeline: tmpTimeline,
          time: tmpTimeline.reduce((s, v) => s + v.end_sec - v.start_sec, 0),
        }
      )
    })
  }, [originTask, task.taskLabeling?.not_working_ranges])

  const workTime = useMemo(() => (
    formatTaskList.filter((v) => v.label?.label_group_id !== 2).reduce((sum, val) => (sum + val.time), 0) || 0
  ), [formatTaskList])

  const labeledWorkTime = useMemo(() => (
    formatTaskList.filter((v) => (
      v.label && !(v.label.status === "suggestion" || v.label.status === "repeat_suggestion" || v.label.label_group_id === 2)
    )).reduce((sum, val) => (sum + val.time), 0) || 0
  ), [formatTaskList])

  const breakTime = useMemo(() => (
    formatTaskList.filter((v) => v.label?.label_group_id === 1).reduce((sum, val) => (sum + val.time), 0) || 0
  ), [formatTaskList])

  const workStartTime = useMemo(() => format(task.taskLabeling?.work_start_time, "YYYY-MM-DD HH:m:s"), [task.taskLabeling?.tasks])

  const workEndTime = useMemo(() => format(task.taskLabeling?.work_end_time, "YYYY-MM-DD HH:m:s"), [task.taskLabeling?.tasks])

  const totalTime = useMemo(() => {
    if (!task.taskLabeling?.work_end_time || !task.taskLabeling?.work_start_time) return 0
    const workStartSec = dateToTodayElapsedSeconds(workStartTime, date)
    const workEndSec = dateToTodayElapsedSeconds(workEndTime, date)
    const targetNotWorkingTime = task.taskLabeling?.not_working_ranges.map((v) => (
      {
        tmpStartSec: dateToTodayElapsedSeconds(v.start_time, date),
        tmpEndSec: dateToTodayElapsedSeconds(v.end_time, date),
      }
    )).filter((v) => workStartSec <= v.tmpStartSec && workEndSec >= v.tmpEndSec).reduce((s, v) => s + v.tmpEndSec - v.tmpStartSec, 0)
    return (workEndSec - workStartSec) - targetNotWorkingTime
  }, [workStartTime, workEndTime, task.taskLabeling?.not_working_ranges])

  const baseWorkStartSeconds = useMemo(() => {
    if (!task.taskLabeling?.base_work_start_time) return 0
    let seconds = dateToTodayElapsedSeconds(task.taskLabeling.base_work_start_time, date)
    if (seconds < 3600 * 5) seconds += 86400
    return seconds
  }, [task.taskLabeling?.base_work_start_time])

  const baseWorkEndSeconds = useMemo(() => {
    if (!task.taskLabeling?.base_work_end_time) return 0
    let seconds = dateToTodayElapsedSeconds(task.taskLabeling.base_work_end_time, date)
    if (seconds < 3600 * 5) seconds += 86400
    return seconds
  }, [task.taskLabeling?.base_work_end_time])

  const member_id = useMemo(() => {
    if (!id) {
      return commonPart.current_member_id
    }
    return Number(id)
  }, [id])

  const isSelf = useMemo(() => {
    if ((!id && !member_id) || !commonPart.current_member_id || Number(member_id) !== commonPart.current_member_id) return false
    return true
  }, [id, commonPart.current_member_id, member_id])

  const displayUser = useMemo(() => {
    if (!member_id) return null
    return task.taskLabeling?.member || null
  }, [member_id, task.taskLabeling?.member])

  const isLocked = useMemo(() => {
    if (
      !task.taskLabeling?.approval_status
      || task.taskLabeling.approval_status === "unapplied"
      || task.taskLabeling.approval_status === "returned"
      || task.taskLabeling.approval_status === "dropped"
      || task.taskLabeling.approval_status === "canceled"
    ) return false
    return true
  }, [task.taskLabeling?.approval_status])

  const buildCheckBox = (value: boolean) => (
    value ? (
      <FontAwesomeIcon
        icon={["fas", "check-square"]}
        style={{ color: "#008800" }}
        fixedWidth
      />
    ) : (
      <FontAwesomeIcon
        icon={["far", "square"]}
        style={{ color: "#999999" }}
        fixedWidth
      />
    )
  )

  const rulerBlock = () => (
    <div className="timeline_ruler_area">
      {
        Array((TIME_LIST.length * 2) - 1).fill(null).map((_v, i) => (
          <div key={`ruler_${i + 0}`} />
        ))
      }
      <div />
    </div>
  )

  const timeAdjuster = (time: string | null) => {
    if (time) {
      const hours = format(time, "k")
      const minutes = format(time, "mm")
      if (Number(hours) > 5) {
        return `${Number(hours)}:${minutes}`
      }
      return `${Number(hours) + 24}:${minutes}`
    }
    return null
  }

  const labelBlock = (display = false, displayNotWorkingRange = false) => (
    <div
      className="timeline_label_area"
      style={{
        width: `${(5 / 6) * 100}%`,
        marginLeft: `${(1 / 6) * 100}%`,
        position: "relative",
        height: "16px",
        marginTop: "4px",
        marginBottom: "4px",
        fontSize: "10px",
        color: "#666666",
      }}
    >
      {
        TIME_LIST.map((v, i) => (
          <React.Fragment key={v}>
            <div
              style={{
                position: "absolute",
                left: `${(i / 24) * 100}%`,
                transform: "translateX(-50%)",
                padding: "2px 4px",
                zIndex: 1,
              }}
            >
              {v}
            </div>
          </React.Fragment>
        ))
      }
      {
        Array(48).fill(null).map((_v, i) => (
          <div
            style={{
              position: "absolute",
              left: `${(i / 48) * 100}%`,
              width: `${100 / 48}%`,
              height: "16px",
              opacity: "0.5",
              backgroundColor: (selectPeriod.includes(i)) ? "#1ba5a5" : "transparent",
            }}
          />
        ))
      }
      {
        displayNotWorkingRange && task.taskLabeling?.not_working_ranges.map((v) => {
          const startSec = dateToTodayElapsedSeconds(v.start_time, date)
          const endSec = dateToTodayElapsedSeconds(v.end_time, date)
          const startPosition = (startSec - (5 * 3600)) / 864
          return (
            <div
              style={{
                position: "absolute",
                top: "21px",
                left: `${startPosition}%`,
                width: `${(endSec - startSec) / 864}%`,
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                height: `calc(43px * ${taskList.length})`,
                zIndex: "1",
              }}
            >
              <Tips
                description="業務外作業時間に設定されています"
                className=""
                icon={false}
              >
                <>
                </>
              </Tips>
            </div>
          )
        })
      }
      {
        display
        && isDisplayBaseWorkTime
        && task.taskLabeling?.base_work_start_time
        && (
          <>
            <div
              style={{
                position: "absolute",
                top: "9px",
                left: `calc(${(dateToTodayElapsedSeconds(task.taskLabeling.base_work_start_time, date) - (5 * 3600)) / 864}%)`,
                transform: "translateX(-50%)",
                color: "#ff9291",
                zIndex: "1",
                fontSize: "14px",
              }}
            >
              <Tips
                description={`標準勤務開始時間 ${timeAdjuster(task.taskLabeling.base_work_start_time)}`}
                className=""
                icon={false}
              >
                <>
                  <FontAwesomeIcon icon={['fas', 'caret-down']} />
                </>
              </Tips>
            </div>
            <div
              style={{
                position: "absolute",
                top: "21px",
                left: `calc(${(dateToTodayElapsedSeconds(task.taskLabeling.base_work_start_time, date) - (5 * 3600)) / 864}%)`,
                transform: "translateX(-50%)",
                backgroundColor: "#ff9291",
                width: "2px",
                height: `calc(42.5px * ${taskList.length})`,
                zIndex: "1",
              }}
            />
          </>
        )
      }
      {
        display
        && isDisplayBaseWorkTime
        && task.taskLabeling?.base_work_end_time
        && (
          <>
            <div
              style={{
                position: "absolute",
                top: "9px",
                left: `calc(${(dateToTodayElapsedSeconds(task.taskLabeling.base_work_end_time, date) - (5 * 3600)) / 864}%)`,
                transform: "translateX(-50%)",
                color: "#ff9291",
                zIndex: "1",
                fontSize: "14px",
              }}
            >
              <Tips
                description={`標準勤務終了時間 ${timeAdjuster(task.taskLabeling.base_work_end_time)}`}
                className=""
                icon={false}
              >
                <>
                  <FontAwesomeIcon icon={['fas', 'caret-down']} />
                </>
              </Tips>
            </div>
            <div
              style={{
                position: "absolute",
                top: "21px",
                left: `calc(${(dateToTodayElapsedSeconds(task.taskLabeling.base_work_end_time, date) - (5 * 3600)) / 864}%)`,
                transform: "translateX(-50%)",
                backgroundColor: "#ff9291",
                width: "2px",
                height: `calc(42.5px * ${taskList.length})`,
                zIndex: "1",
              }}
            />
          </>
        )
      }
    </div>
  )

  const reload = () => {
    setWait(true)
    setAddTaskIds([])
    setCheckedTaskIds([])
    setTmpTaskIds([])
    setIsLabeledInNotWorkingRange(false)
    dispatch(
      fetchTaskLabeling(
        { member_id: Number(member_id), target_date: date },
      ),
    )
    setTimeout(() => {
      setWait(false)
    }, 3000)
  }

  const openAddLabelModule = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, taskIds: number[]) => {
    setCheckedTaskIds([])
    setSelectTask({ ids: taskIds, x: 425, y: event.clientY - 220 + window.scrollY })
  }

  const openAddLabelMultiTaskModule = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, taskIds: number[]) => {
    setSelectTask({ ids: taskIds, x: 60, y: 60, isFixed: true })
  }

  const addLabel = (taskIds: number[], labelGroup: LabelCommon, label: LabelCommon, option?: string) => {
    setTmpTaskIds(taskIds)
    dispatch(
      createTaskLabeling(
        { task_ids: taskIds, label_group: labelGroup, label: label, option: option },
        () => {
          taskIds.forEach((v) => {
            const targetEl = document.getElementById(`task_id_${v.toString()}`)
            targetEl?.classList.add("new")
            setTimeout(() => {
              targetEl?.classList.remove("new")
            }, 5000)
          })
          if (taskIds.length > 1) {
            alert.success(`${taskIds.length}件の作業データを業務仕分けしました`)
            setTmpTaskIds([])
            if (labelGroup.id === 2) reload()
            return
          }
          alert.success(`${taskList.find((v) => v.task_id === taskIds[0])?.task_name}を業務仕分けしました`)
          setTmpTaskIds([])
          if (labelGroup.id === 2) reload()
        },
      ),
    )
    setAddTaskIds([...addTaskIds, ...taskIds])
    setCheckedTaskIds([])
  }

  const delLabel = (taskIds: number[], labelGroupId: number, labelId: number, persistence?: boolean) => {
    setTmpTaskIds(taskIds)
    dispatch(
      destroyTaskLabeling(
        {
          task_ids: taskIds,
          label_group_id: labelGroupId,
          label_id: labelId,
          cancel_repeat: persistence || false,
        },
        () => {
          setTmpTaskIds([])
          if (labelGroupId === 2) reload()
        },
      ),
    )
    setAddTaskIds(addTaskIds.filter((v) => !taskIds.includes(v)))
  }

  const multiDelLabel = (taskIds: number[]) => {
    delLabel(taskIds, 0, 0)
    alert.success(`${taskIds.length}件の業務仕分けを解除しました`)
    setCheckedTaskIds([])
  }

  const modLabelName = (taskId: number, name: string) => {
    dispatch(
      updateTaskLabeling(
        { task_id: taskId, task_name: name },
      ),
    )
  }

  const closeConfirmationModal = () => {
    setConfirmationModalState({
      ...confirmationModalState,
      display: false,
      taskId: 0,
      labelId: 0,
      labelGroupId: 0,
      callback: () => {
        // none
      },
    })
  }

  const openConfirmationModal = (taskId: number, labelGroupId: number, labelId: number) => {
    setCheckedTaskIds([])
    setConfirmationModalState({
      ...confirmationModalState,
      display: true,
      taskId: taskId,
      labelId: labelId,
      labelGroupId: labelGroupId,
      callback: (cbTaskId, cbLabelGroupId, cbLabelId, persistence) => delLabel([cbTaskId], cbLabelGroupId, cbLabelId, persistence),
    })
  }

  const hoverCalender = (startTime: string, endTime: string) => {
    const tmpTargetTaskIds = task.taskLabeling?.tasks?.filter((v) => v.timeline.filter((w) => (
      (w.start_time >= startTime && w.end_time <= endTime)
      || (w.start_time < startTime && w.end_time >= startTime && w.end_time <= endTime)
      || (w.end_time > endTime && w.start_time >= startTime && w.start_time <= endTime)
    )).length).map((v) => v.task_id) || []
    setTargetTaskIds(tmpTargetTaskIds)
    if (holdText === startTime) return
    setHoldText("")
  }

  const blurCalender = () => {
    if (holdText) return
    setTargetTaskIds([])
  }

  const calcLeftPosition = (tmpStartSec: number) => `${((((tmpStartSec - 18000) / 86400) * (5 / 6)) + (1 / 6)) * 100}%`

  const calcWidth = (tmpStartSec: number, tmpEndSec: number) => `${(((tmpEndSec - tmpStartSec) / 86400) * (5 / 6)) * 100}%`

  const addTask = (
    name: string | null,
    labelId: number | null,
    timeline: {startTime: number, endTime: number}[],
    selectTimeList: {
      startSec: number,
      endSec: number,
    }[],
    isNotBelong: boolean,
    originTaskId: number | null,
    mode: string,
    afterFunc?: () => void,
  ) => {
    setCheckedTaskIds([])
    if (mode === "create") {
      let buildTimeline = timeline.filter((v) => v.endTime - v.startTime).map((v) => (
        {
          start_time: buildTime(v.startTime),
          end_time: buildTime(v.endTime),
        }
      ))
      if (login.permissions?.task_overwrite_break_time && labelId === 1) {
        buildTimeline = selectTimeList.map((v) => (
          {
            start_time: buildTime(v.startSec),
            end_time: buildTime(v.endSec),
          }
        ))
      }
      const params:AddTask = {
        member_id: member_id || 0,
        date: date,
        name: name,
        timeline: buildTimeline,
      }
      if (labelId || isNotBelong) {
        params.label_id = labelId || 0
      }
      dispatch(
        createTaskManual(
          params,
          (taskId) => {
            alert.success("作業データを登録しました")
            const targetEl = document.getElementById(`task_id_${taskId.toString()}`)
            targetEl?.scrollIntoView({ behavior: 'smooth', block: "center" })
            targetEl?.classList.add("new")
            setTimeout(() => {
              targetEl?.classList.remove("new")
            }, 5000)
            if (afterFunc) {
              afterFunc()
            }
            setIsLoadingManualTask(true)
            dispatch(
              fetchTaskLabeling(
                { member_id: Number(member_id), target_date: date },
                false,
                () => {
                  setIsLoadingManualTask(false)
                },
              ),
            )
          },
        ),
      )
    } else if (mode === "cut") {
      const params:CutTask = {
        origin_task_id: originTaskId || 0,
        start_time: buildTime(selectTimeList[0].startSec),
        end_time: buildTime(selectTimeList[0].endSec),
        name: name || "",
      }
      if (labelId || isNotBelong) {
        params.label_id = labelId || 0
      }
      dispatch(
        createTaskSeparate(
          params,
          (taskId) => {
            alert.success("作業データを切り出しました")
            const targetEl = document.getElementById(`task_id_${taskId.toString()}`)
            targetEl?.scrollIntoView({ behavior: 'smooth', block: "center" })
            targetEl?.classList.add("new")
            setTimeout(() => {
              targetEl?.classList.remove("new")
            }, 5000)
            if (afterFunc) {
              afterFunc()
            }
          },
        ),
      )
    }
  }

  const delTask = (taskId: number, labelId: number, delType: string) => {
    setCheckedTaskIds([])
    if (delType === "delete") {
      dispatch(
        destroyTaskManual(
          { id: taskId },
          () => {
            alert.success("作業データを削除しました")
            setIsLoadingManualTask(true)
            dispatch(
              fetchTaskLabeling(
                { member_id: Number(member_id), target_date: date },
                false,
                () => {
                  setIsLoadingManualTask(false)
                },
              ),
            )
          },
        ),
      )
    }
    if (delType === "reverse") {
      dispatch(
        destroyTaskSeparate(
          { id: taskId },
          () => {
            alert.success("元の作業データに戻しました")
            setIsLoadingManualTask(true)
            dispatch(
              fetchTaskLabeling(
                { member_id: Number(member_id), target_date: date },
                false,
                () => {
                  setIsLoadingManualTask(false)
                },
              ),
            )
          },
        ),
      )
    }
  }

  const changeSortType = (taskSortType: string) => {
    setSortType(taskSortType)
    dispatch(updateTaskLabelingSortType(taskSortType))
  }

  const openCutTaskModal = (taskId: number) => {
    setCheckedTaskIds([])
    const tmpOriginTask = taskList.find((v) => v.task_id === taskId)
    if (!originTask) return
    setCutTaskOrigin(tmpOriginTask)
    setType("cut")
    setIsDisplayCutModal(true)
  }

  const closeCutTaskModal = () => {
    setIsDisplayCutModal(false)
    setCutTaskOrigin(undefined)
    setSelectPeriod([])
  }

  const openExclusionAutoLabelingTaskModal = (taskId: number) => {
    const targetTask = taskList.find((v) => v.task_id === taskId)
    if (!targetTask) return
    setExclusionTask(targetTask)
    setIsDisplayExclusionModal(true)
  }

  const closeExclusionAutoLabelingTaskModal = () => {
    setExclusionTask(undefined)
    setIsDisplayExclusionModal(false)
  }

  const clickPeriod = (num: number) => {
    if (!selectPeriod.length) {
      setSelectPeriod([num, num + 1])
      return
    }
    if (selectPeriod.includes(num)) {
      setSelectPeriod(selectPeriod.filter((v) => v !== num).sort((a, b) => a - b))
    } else {
      setSelectPeriod([...selectPeriod, num].sort((a, b) => a - b))
    }
  }

  const createRangeTask = () => {
    setCutTaskOrigin({
      task_id: 0,
      type: "ActiveTask",
      origin_task_id: null,
      time: 0,
      service_name: null,
      icon: null,
      icon_color: null,
      task_name: null,
      file_path: null,
      included_url_parts: null,
      url: null,
      exclusion_id: null,
      timeline: untrackedTask,
      label: null,
    })
    setType("create")
    setIsDisplayCutModal(true)
  }

  const clickTaskRow = (taskId: number) => {
    if (checkedTaskIds.includes(taskId)) {
      setCheckedTaskIds(checkedTaskIds.filter((v) => v !== taskId))
    } else {
      setCheckedTaskIds([...checkedTaskIds, taskId])
    }
    if (!current.taskLabelingGuide) {
      setIsOpenLabelingGuide(true)
      dispatch(updateTaskLabelingGuide(true))
    }
  }

  const selectTaskRowWithCtrlKey = (event: React.MouseEvent<HTMLDivElement>, taskId: number) => {
    if (isLocked) return
    if (event.ctrlKey || event.metaKey) {
      clickTaskRow(taskId)
    }
  }

  const selectTaskRowWithShiftKey = (event: React.MouseEvent<HTMLDivElement>, taskId: number) => {
    if (isLocked) return
    if (event.shiftKey && event.buttons === 1) {
      setCheckedTaskIds((cur) => Array.from(new Set([...cur, taskId])))
    }
  }

  const clickTaskAllRow = () => {
    if (taskList.length === checkedTaskIds.length) {
      setCheckedTaskIds([])
    } else {
      setCheckedTaskIds(taskList.map((v) => v.task_id))
    }
    if (!current.taskLabelingGuide) {
      setIsOpenLabelingGuide(true)
      dispatch(updateTaskLabelingGuide(true))
    }
  }

  const clickDetail = (memberData: DetailParam) => {
    setDetailData(memberData)
    setIsOpenDetailModal(true)
    dispatch(
      fetchTaskApprovalApplicationDetail(
        {
          id: memberData.member_id.toString(),
          target_date: memberData.target_date,
        },
      ),
    )
  }

  const updateApproval = (param: UpdateParam, callback: VoidFunction) => {
    let tmpTarget:{target_date: string, member_id: number, comment: string, start_time?: string, end_time?: string} = {
      target_date: param.target_date,
      member_id: param.member_id,
      comment: param.comment,
    }
    if (param.work_start_time) {
      if (param.work_end_time) {
        tmpTarget = {
          ...tmpTarget,
          start_time: format(param.work_start_time, "YYYY-MM-DD HH:mm:ss"),
          end_time: format(param.work_end_time, "YYYY-MM-DD HH:mm:ss"),
        }
      } else {
        tmpTarget = {
          ...tmpTarget,
          start_time: format(param.work_start_time, "YYYY-MM-DD HH:mm:ss"),
        }
      }
    }
    const tmpParam = {
      status: param.status,
      targets: [tmpTarget],
    }
    const isComplete = Boolean(param.status === "approved"
      && task.taskApprovalApplicationDetail?.approvers.filter((v) => v.member_id === login.current_member_id && !v.priority).length)
    dispatch(
      createTaskApprovalApplication(
        tmpParam,
        isComplete,
        () => {
          callback()
          alert.success(`${format(param.target_date, "YYYY年M月D日")}の申請データを「${statusText(param.status)}」に変更しました`)
          dispatch(changeTaskLabelingStatus({
            status: "processing",
          }))
          reload()
        },
      ),
    )
  }

  const buildSecToTime = (sec: number, isText = false) => {
    if (isText) {
      let tmpText = ""
      if (Number(secToHour(sec))) {
        tmpText += `${secToHour(sec)}時間`
      }
      if (Number(secToMinute(sec))) {
        tmpText += `${secToMinute(sec)}分`
      } else {
        tmpText += "0分"
      }
      if (Number(secToSec(sec))) {
        tmpText += `${secToSec(sec)}秒`
      }
      return tmpText
    }
    return (
      <>
        {
          !!Number(secToHour(sec)) && (
            <>
              {`${secToHour(sec)}時間`}
            </>
          )
        }
        {
          Number(secToMinute(sec)) ? (
            <>
              {`${secToMinute(sec)}分`}
            </>
          ) : (
            <>
              0分
            </>
          )
        }
        {
          !!Number(secToSec(sec)) && (
            <>
              {`${secToSec(sec)}秒`}
            </>
          )
        }
      </>
    )
  }

  const reservedLabelClass = (labelGroupId: number) => {
    if (labelGroupId <= RESERVED_LABEL_GROUP_ID) {
      if (labelGroupId === 0) {
        return "not_belong"
      }
      if (labelGroupId === 1) {
        return "break"
      }
      if (labelGroupId === 2) {
        return "not_working"
      }
    }
    return ""
  }

  const reservedLabelIcon = (labelGroupId: number) => {
    if (labelGroupId <= RESERVED_LABEL_GROUP_ID) {
      if (labelGroupId === 0) {
        return "question"
      }
      if (labelGroupId === 1) {
        return "star"
      }
      if (labelGroupId === 2) {
        return "exclamation-circle"
      }
    }
    return ""
  }

  const updateExclusion = (targetId: number, targetType: string) => {
    if (targetType === "create") {
      dispatch(
        createTaskExcludeAutoLabelingTask(
          { task_id: targetId },
          () => {
            alert.success("対象の作業データを自動仕分け対象外に設定しました")
            closeExclusionAutoLabelingTaskModal()
          },
        ),
      )
    } else if (targetType === "delete") {
      dispatch(
        destroyTaskExcludeAutoLabelingTask(
          { id: targetId },
          () => {
            alert.success("対象の作業データを自動仕分け対象外から解除しました")
            closeExclusionAutoLabelingTaskModal()
          },
        ),
      )
    }
  }

  const buildDisplayTime = (diffSeconds: number) => {
    if (diffSeconds > 0 && diffSeconds < 60) {
      return "1分未満"
    }
    if (secToHour(diffSeconds)) {
      return `${secToHour(diffSeconds)}時間${secToMinute(diffSeconds)}分`
    }
    return `${secToMinute(diffSeconds)}分`
  }

  const openNotWorkingModal = () => {
    setIsOpenNotWorkingModal(true)
    setIsLoadingNotWorkingModal(true)
    dispatch(
      fetchTaskNotWorkingRange(
        { member_id: Number(member_id), target_date: date },
        () => {
          setIsLoadingNotWorkingModal(false)
        },
      ),
    )
  }

  const closeNotWorkingModal = () => {
    setIsOpenNotWorkingModal(false)
  }

  const updateRange = (ranges: {start_time: string, end_time: string}[], afterFunc?: () => void) => {
    dispatch(
      updateTaskNotWorkingRange(
        { member_id: Number(member_id), target_date: date, not_working_ranges: ranges },
        () => {
          alert.success(`作業データの業務外範囲を${ranges.length ? "設定" : "削除"}しました`)
          if (afterFunc) {
            afterFunc()
          }
          dispatch(
            fetchTaskLabeling(
              { member_id: Number(member_id), target_date: date },
              false,
            ),
          )
        },
      ),
    )
  }

  const toggleDisplayBaseWorkTime = (isDisplay: boolean) => {
    setIsDisplayBaseWorkTime(isDisplay)
    dispatch(
      updateTaskLabelingBaseWorkTimeView(isDisplay),
    )
  }

  useEffect(() => {
    setIsDisplayBaseWorkTime(current.taskLabelingBaseWorkTimeView)
    setSortType(current.taskLabelingSortType)
  }, [current])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    if (!date) return
    setIsLabeledInNotWorkingRange(false)
    dispatch(
      fetchTaskLabeling(
        { member_id: Number(member_id), target_date: date },
      ),
    )
  }, [date, location])

  useEffect(() => {
    const getParams = getGetPrams(location.search) as GetParams
    if (getParams.date) {
      setDate(format(getParams.date, "YYYY-MM-DD"))
      return
    }
    setDate(nowDate("YYYY-MM-DD"))
  }, [])

  useEffect(() => {
    if (!task.taskLabeling?.untracked_tasks) return
    setUntrackedTask(task.taskLabeling?.untracked_tasks.map((v) => ({
      ...v,
      start_sec: dateToTodayElapsedSeconds(v.start_time, date),
      end_sec: dateToTodayElapsedSeconds(v.end_time, date),
    })) || [])
  }, [task.taskLabeling?.untracked_tasks])

  useEffect(() => {
    let labelGroupList:GraphItem[] = []
    let labelList:GraphItem[] = []
    formatTaskList.filter((v) => (v.label?.label_group_id && v.label.label_group_id > 2)).forEach((v) => {
      if (!v.label || (v.label.status === "suggestion" || v.label.status === "repeat_suggestion")) {
        return
      }
      if (!labelGroupList.map((w) => w.name).includes(v.label.label_group_name)) {
        labelGroupList.push({ name: v.label.label_group_name, color: v.label.label_group_color, value: v.time })
      } else {
        labelGroupList = labelGroupList.map((w) => (w.name === v.label?.label_group_name ? { ...w, value: w.value + v.time } : w))
      }
      if (!labelList.map((w) => w.name).includes(v.label.label_name)) {
        labelList.push({ name: v.label.label_name, color: v.label.label_color, value: v.time })
      } else {
        labelList = labelList.map((w) => (w.name === v.label?.label_name ? { ...w, value: w.value + v.time } : w))
      }
    })
    labelGroupList.sort((a, b) => b.value - a.value)
    labelList.sort((a, b) => b.value - a.value)
    setTaskCategorize({ label_groups: labelGroupList, labels: labelList })
    setFetchTrigger(true)
  }, [formatTaskList])

  useEffect(() => {
    if (fetchTrigger && isLocked && !isSelf && date && !!task.taskLabeling?.not_working_ranges.length) {
      openNotWorkingModal()
    }
    setFetchTrigger(false)
  }, [fetchTrigger])

  useEffect(() => {
    if (!task.taskLabeling?.tasks) return
    const tmpList = task.taskLabeling?.tasks
    if (sortType === "measure") {
      const tmpOrg: TaskDetail[] = tmpList.filter((v) => !v.origin_task_id)
      const buildTaskList: TaskDetail[] = []
      tmpOrg.forEach((v) => {
        if (tmpList.filter((w) => w.origin_task_id === v.task_id).length) {
          buildTaskList.push(v)
          tmpList.filter((w) => w.origin_task_id === v.task_id).forEach((w) => (
            buildTaskList.push(w)
          ))
        } else {
          buildTaskList.push(v)
        }
      })
      setTaskList(buildTaskList)
    }
    if (sortType === "time") {
      setTaskList(
        sortBy(tmpList, "time").reverse(),
      )
    }
    if (sortType === "app") {
      const tmpOrg: TaskDetail[] = sortBy(tmpList.filter((v) => !v.origin_task_id), "service_name")
      const buildTaskList: TaskDetail[] = []
      tmpOrg.forEach((v) => {
        if (tmpList.filter((w) => w.origin_task_id === v.task_id).length) {
          buildTaskList.push(v)
          tmpList.filter((w) => w.origin_task_id === v.task_id).forEach((w) => (
            buildTaskList.push(w)
          ))
        } else {
          buildTaskList.push(v)
        }
      })
      setTaskList(buildTaskList)
    }
    if (sortType === "label") {
      setTaskList([
        ...tmpList.filter((v) => (
          ((!v.label?.label_id && v.label?.label_id !== 0) || v.label.status === "suggestion" || v.label.status === "repeat_suggestion")
        )),
        ...tmpList.filter((v) => (
          ((v.label?.label_id || v.label?.label_id === 0) && v.label.status !== "suggestion" && v.label.status !== "repeat_suggestion")
        )),
      ])
    }
  }, [sortType, task.taskLabeling?.tasks])

  const displayTaskList = useMemo(() => (
    <>
      <div className="timeline">
        {
          taskList?.map((data, i) => (
            <div
              className={`${targetTaskIds.includes(data.task_id) ? "hold" : ""} ${selectPeriodTaskIds.includes(data.task_id) ? "hold_period" : ""}`}
              key={`${data.task_name}_${data.time}_${i + 1}`}
              onClick={(event) => selectTaskRowWithCtrlKey(event, data.task_id)}
              onMouseMove={(event) => selectTaskRowWithShiftKey(event, data.task_id)}
              role="none"
            >
              <LabelingModule
                data={data}
                openCallback={(e) => openAddLabelModule(e, [data.task_id])}
                addCallback={(labelGroup, label, option?) => addLabel([data.task_id], labelGroup, label, option)}
                delCallback={(labelGroupId, labelId) => delLabel([data.task_id], labelGroupId, labelId)}
                delConfirmCallback={(labelGroupId, labelId) => openConfirmationModal(data.task_id, labelGroupId, labelId)}
                changeNameCallback={(taskId, name) => modLabelName(taskId, name)}
                delTaskCallback={(taskId, labelId, delType) => delTask(taskId, labelId, delType)}
                cutTaskCallback={(taskId) => openCutTaskModal(taskId)}
                exclusionAutoLabelingTaskCallback={(taskId) => openExclusionAutoLabelingTaskModal(taskId)}
                originTitle={
                  data.origin_task_id ? taskList.find((v) => v.task_id === data.origin_task_id)?.task_name || null : null
                }
                clickCheckboxCallback={(taskId) => clickTaskRow(taskId)}
                isChecked={checkedTaskIds.includes(data.task_id)}
                isLocked={isLocked}
                isSideOpen={current.sideOpen}
                date={date}
                isLoading={tmpTaskIds.includes(data.task_id)}
                reservedLabelGroupId={RESERVED_LABEL_GROUP_ID}
                baseWorkStartSeconds={baseWorkStartSeconds}
                baseWorkEndSeconds={baseWorkEndSeconds}
                isDisplayBaseWorkTime={isDisplayBaseWorkTime}
              />
            </div>
          ))
        }
      </div>
    </>
  ), [taskList, targetTaskIds, tmpTaskIds, checkedTaskIds, current.sideOpen, selectPeriodTaskIds, isDisplayBaseWorkTime])

  const displayUntrackedTask = useMemo(() => {
    const others = task.taskLabeling?.others.map((v) => ({
      ...v,
      start_sec: dateToTodayElapsedSeconds(v.start_time, date),
      end_sec: dateToTodayElapsedSeconds(v.end_time, date),
    })) || []
    const tmpList: FormatOther[] = []
    others.forEach((v) => {
      untrackedTask.forEach((w) => {
        if (v.start_sec <= w.end_sec && v.end_sec >= w.start_sec) {
          let tmpStartSec = v.start_sec
          let tmpEndSec = v.end_sec
          if (v.start_sec < w.start_sec) {
            tmpStartSec = w.start_sec
          }
          if (v.end_sec > w.end_sec) {
            tmpEndSec = w.end_sec
          }
          tmpList.push({ ...v, start_sec: tmpStartSec, end_sec: tmpEndSec })
        }
      })
    })
    return (
      <>
        {
          untrackedTask.map((value) => (
            <React.Fragment key={`untracked_${value.start_time}`}>
              <div
                className="timeline_item"
                style={{
                  left: calcLeftPosition(value.start_sec),
                  width: calcWidth(value.start_sec, value.end_sec),
                  zIndex: 0,
                }}
              />
            </React.Fragment>
          ))
        }
        {
          tmpList.map((value) => (
            <React.Fragment key={`untracked_duplicate_${value.start_time}`}>
              <div
                className="timeline_item duplicate"
                style={{
                  left: calcLeftPosition(value.start_sec),
                  width: calcWidth(value.start_sec, value.end_sec),
                  zIndex: 0,
                }}
              />
            </React.Fragment>
          ))
        }
      </>
    )
  }, [untrackedTask])

  const displayCalendarSchedules = useMemo(() => (
    <>
      {
        task.taskLabeling?.calendar.schedules.map((value) => (
          <React.Fragment key={`calendar_${value.start_time}`}>
            <div
              className={`timeline_item${value.start_time === holdText ? " hold" : ""}`}
              style={{
                left: calcLeftPosition(dateToTodayElapsedSeconds(value.start_time, date)),
                width: calcWidth(dateToTodayElapsedSeconds(value.start_time, date), dateToTodayElapsedSeconds(value.end_time, date)),
              }}
              onMouseOver={() => hoverCalender(value.start_time, value.end_time)}
              onFocus={() => { /* */ }}
              onMouseLeave={() => blurCalender()}
              onClick={() => setHoldText(holdText === value.start_time ? "" : value.start_time)}
              role="none"
            >
              <Tips
                description={`${format(value.start_time, "HH時mm分")} ~ ${format(value.end_time, "HH時mm分")} ${value.title}`}
                className=""
                icon={false}
              >
                <>
                  {
                    value.start_time === holdText && (
                      <FontAwesomeIcon icon={['fas', 'stopwatch']} />
                    )
                  }
                </>
              </Tips>
            </div>
          </React.Fragment>
        ))
      }
    </>
  ), [task.taskLabeling?.calendar.schedules, holdText])

  return (
    <section className="task_page">
      <Helmet>
        <title>Qasee - 工数管理 - 業務仕分け</title>
      </Helmet>
      {
        isManager(login.role) && (
          <section className="breadcrumb">
            工数管理
            &nbsp;&gt;&nbsp;
            {
              isSelf || (
                <>
                  <Link
                    to={setPath(URL.TASK_LABELING_STATUS.path, language)}
                  >
                    仕分け状況一覧
                  </Link>
                  &nbsp;&gt;&nbsp;
                </>
              )
            }
            {displayUser?.name}
            さんの業務仕分け
            &nbsp;
          </section>
        )
      }
      <section className="page_header">
        <h1>
          {displayUser?.name}
          さんの業務仕分け
          <VideoGuide
            videoId="YlRQFFsI-Bg"
          />
        </h1>
        <div className="tools">
          <DateCalendarModule
            date={date}
            changeCallback={(callback_date) => {
              setDate(callback_date)
              dispatch(updateCurrentDate(callback_date))
              history.push(`${location.pathname}?date=${callback_date}`)
            }}
            disabled={task.isLoading || false}
          />
        </div>
      </section>
      <section className="page_contents content-area" style={{ marginBottom: isDisplayPanel ? "180px" : "50px" }}>
        {
          isLocked && (
            <div
              className="lock_belt"
              style={{
                backgroundColor: labelColor(task.taskLabeling?.approval_status || ""),
              }}
            >
              <div>
                この仕分けデータは
                {`「${statusText(task.taskLabeling?.approval_status || "")}」のため、編集できません`}
              </div>
            </div>
          )
        }
        <div className="content-block">
          {
            isSelf || (
              <div className="user_display_area">
                {
                  displayUser?.profile_image ? (
                    <img alt="profile" src={displayUser.profile_image} className="profile_icon" />
                  ) : (
                    <img
                      alt=""
                      src={`/static/images/profile/${(member_id || 0) % 12}.jpeg`}
                      className="profile_icon"
                    />
                  )
                }
                <div className="text">
                  <span className="user_name">
                    {displayUser?.name}
                  </span>
                  さんのデータを表示しています
                </div>
              </div>
            )
          }
          <div className="block-header labeling_header">
            {
              task.isLoading ? (
                <></>
              ) : (
                <>
                  <div className="labeling_summary">
                    <div
                      style={{
                        display: "flex",
                        flexFlow: "column",
                        gap: "16px",
                        paddingTop: "16px",
                      }}
                    >
                      <div className="summary_block" style={{ backgroundColor: "#0B9554" }}>
                        <div>
                          <Tips
                            description="仕分け済み作業データの合計時間を表示しています。"
                            className=""
                          >
                            <>
                              仕分け済み
                            </>
                          </Tips>
                        </div>
                        <div className="numerator">
                          {secToHourMinute(labeledWorkTime)}
                          <div className="seconds">
                            {`:${secToTwoDigitsSec(labeledWorkTime)}`}
                          </div>
                        </div>
                      </div>
                      <div className="summary_block" style={{ backgroundColor: "#C61616" }}>
                        <div>
                          <Tips
                            description="未仕分け作業データの合計時間を表示しています。"
                            className=""
                          >
                            <>
                              未仕分け
                            </>
                          </Tips>
                        </div>
                        <div className="numerator">
                          {secToHourMinute(workTime - labeledWorkTime)}
                          <div className="seconds">
                            {`:${secToTwoDigitsSec(workTime - labeledWorkTime)}`}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        仕分け内訳
                      </div>
                      <div
                        style={{
                          display: "flex",
                          gap: "100px",
                          marginLeft: "140px",
                        }}
                      >
                        <div>
                          <SvgPieChart
                            list={taskCategorize.label_groups.map((v) => (
                              {
                                label: v.name,
                                value: v.value,
                                color: v.color,
                              }
                            ))}
                            graphTitle="プロジェクト別"
                            chartSize={150}
                            displayOuterLabel
                          />
                        </div>
                        <div>
                          <SvgPieChart
                            list={taskCategorize.labels.map((v) => (
                              {
                                label: v.name,
                                value: v.value,
                                color: v.color,
                              }
                            ))}
                            graphTitle="業務別"
                            chartSize={150}
                            displayOuterLabel
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )
            }
          </div>
          <div className="labeling_header" style={{ marginBottom: "8px" }}>
            {
              task.isLoading ? (
                <></>
              ) : (
                <>
                  {
                    (!!task.taskLabeling?.work_start_time && !!task.taskLabeling?.work_end_time && Number(format(date, "YYYYMMDD")) > 20240430) ? (
                      <div className="work_time_wrapper">
                        <div className="work_time_area">
                          <div className="work_time_block">
                            <Tips
                              description="業務時間外範囲を除く取得データの最も早い時刻"
                              className=""
                              icon={false}
                            >
                              <>
                                <div
                                  className="work_time_label"
                                  style={{
                                    backgroundColor: "#2196F3",
                                  }}
                                >
                                  勤務開始時刻
                                </div>
                              </>
                            </Tips>
                            <div className="work_time_value">
                              {secToHourMinute(dateToTodayElapsedSeconds(workStartTime, date))}
                            </div>
                          </div>
                          <div>
                            ~
                          </div>
                          <div className="work_time_block">
                            <Tips
                              description="業務時間外範囲を除く取得データの最も遅い時刻"
                              className=""
                              icon={false}
                            >
                              <>
                                <div
                                  className="work_time_label"
                                  style={{
                                    backgroundColor: "#E91E63",
                                  }}
                                >
                                  勤務終了時刻
                                </div>
                              </>
                            </Tips>
                            <div className="work_time_value">
                              {secToHourMinute(dateToTodayElapsedSeconds(workEndTime, date))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div />
                    )
                  }
                  <div className="labeling_control">
                    作業データの並び：
                    <div className="select_wrap">
                      <select
                        onChange={(e) => changeSortType(e.target.value)}
                        defaultValue={sortType}
                      >
                        <option value="measure">
                          計測順
                        </option>
                        <option value="time">
                          時間が多い順
                        </option>
                        <option value="app">
                          アプリ順
                        </option>
                        <option value="label">
                          仕分け順
                        </option>
                      </select>
                    </div>
                    <button
                      type="button"
                      onClick={() => setIsDisplayUseLabel(true)}
                    >
                      <Tips
                        description="対象アプリケーション"
                        className=""
                        icon={false}
                      >
                        <>
                          <FontAwesomeIcon icon={['fas', 'icons']} />
                        </>
                      </Tips>
                    </button>
                    <div className="button_area">
                      <button
                        type="button"
                        className="reload"
                        onClick={reload}
                        disabled={wait}
                      >
                        <Tips
                          description="最新の情報に更新"
                          className=""
                          icon={false}
                        >
                          <>
                            <FontAwesomeIcon icon={['fas', 'sync-alt']} />
                          </>
                        </Tips>
                      </button>
                    </div>
                    {
                      !!workTime
                      && login.function_enabled_state?.task_management_approval
                      && (
                        task.taskLabeling?.requester_is_approver
                        || isSelf
                      )
                      && Number(format(date, "YYYYMMDD")) > 20240430 && (
                        <>
                          {
                            task.taskLabeling?.application_possible ? (
                              <button
                                type="button"
                                className="button"
                                style={{
                                  backgroundColor: labelColor("approved", true),
                                  color: labelColor("approved"),
                                  border: `solid 1px ${labelColor("approved")}`,
                                  fontSize: "12px",
                                }}
                                onClick={() => clickDetail({
                                  member_id: member_id || 0,
                                  member_name: displayUser?.name || "",
                                  target_date: date,
                                })}
                              >
                                {
                                  !isLocked && isSelf ? (
                                    <>
                                      仕分けを完了して申請する
                                    </>
                                  ) : (
                                    <>
                                      申請状況を確認
                                    </>
                                  )
                                }
                              </button>
                            ) : (
                              <Tips
                                description="管理者の設定により申請・承認機能が有効になっていません"
                                className=""
                                icon={false}
                              >
                                <>
                                  <button
                                    type="button"
                                    className="button"
                                    style={{
                                      backgroundColor: "#EEEEEE",
                                      color: "#999999",
                                      border: "solid 1px #999999",
                                      fontSize: "12px",
                                    }}
                                    disabled
                                  >
                                    仕分けを完了して申請する
                                  </button>
                                </>
                              </Tips>
                            )
                          }
                        </>
                      )
                    }
                  </div>
                </>
              )
            }
          </div>
          <div className="labeling_header" style={{ marginBottom: "8px" }}>
            {
              task.isLoading ? (
                <></>
              ) : (
                <>
                  {
                    (!!task.taskLabeling?.work_start_time && !!task.taskLabeling?.work_end_time && Number(format(date, "YYYYMMDD")) > 20240430) ? (
                      <>
                        <div className="work_time_wrapper">
                          <div className="work_time_area">
                            <div className="work_time_block">
                              <Tips
                                description="勤務開始~終了時間から休憩時間と業務内にある業務時間外範囲時間を引いた時間"
                                className=""
                                icon={false}
                              >
                                <>
                                  <div
                                    className="work_time_label"
                                    style={{
                                      backgroundColor: "#2196F3",
                                    }}
                                  >
                                    実労働時間
                                  </div>
                                </>
                              </Tips>
                              <div className="work_time_value min">
                                {buildSecToTime(totalTime - breakTime)}
                              </div>
                            </div>
                            <div className="work_time_block">
                              <Tips
                                description="休憩ラベルをつけた作業データの合計時間"
                                className=""
                                icon={false}
                              >
                                <>
                                  <div
                                    className="work_time_label"
                                    style={{
                                      backgroundColor: "#e88042",
                                    }}
                                  >
                                    休憩時間
                                  </div>
                                </>
                              </Tips>
                              <div className="work_time_value min">
                                {
                                  breakTime > 0 ? (
                                    <>
                                      {buildSecToTime(breakTime)}
                                    </>
                                  ) : (
                                    <>
                                      休憩なし
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            <div className="work_time_block">
                              <Tips
                                description={`実労働時間から標準勤務時間(${buildSecToTime((task.taskLabeling.base_work_time || 28800), true)})を引いた時間`}
                                className=""
                                icon={false}
                              >
                                <>
                                  <div
                                    className="work_time_label"
                                    style={{
                                      backgroundColor: "#7d0000",
                                    }}
                                  >
                                    残業時間
                                  </div>
                                </>
                              </Tips>
                              <div className="work_time_value min">
                                {
                                  (totalTime - (breakTime + (task.taskLabeling.base_work_time || 28800))) > 0 ? (
                                    <>
                                      {buildSecToTime(totalTime - (breakTime + (task.taskLabeling.base_work_time || 28800)))}
                                    </>
                                  ) : (
                                    <>
                                      残業なし
                                    </>
                                  )
                                }
                              </div>
                            </div>
                            {
                              !!task.taskLabeling?.not_working_ranges.length && (
                                <>
                                  <div className="work_time_block">
                                    <Tips
                                      description="業務時間外範囲の合計時間"
                                      className=""
                                      icon={false}
                                    >
                                      <>
                                        <div
                                          className="work_time_label"
                                          style={{
                                            backgroundColor: "#4a4a4a",
                                          }}
                                        >
                                          業務時間外範囲の合計時間
                                        </div>
                                      </>
                                    </Tips>
                                    <div className="work_time_value min">
                                      {
                                        // eslint-disable-next-line max-len
                                        task.taskLabeling?.not_working_ranges.reduce((s, v) => s + (dateToTodayElapsedSeconds(v.end_time, date) - dateToTodayElapsedSeconds(v.start_time, date)), 0) > 0 ? (
                                          <>
                                            { /* eslint-disable-next-line max-len */ }
                                            {buildSecToTime(task.taskLabeling?.not_working_ranges.reduce((s, v) => s + (dateToTodayElapsedSeconds(v.end_time, date) - dateToTodayElapsedSeconds(v.start_time, date)), 0))}
                                          </>
                                        ) : (
                                          <>
                                            なし
                                          </>
                                        )
                                      }
                                    </div>
                                  </div>
                                </>
                              )
                            }
                            {
                              (isSelf || login.display_create_manual_task) && (
                                <>
                                  <div className="work_time_block">
                                    <Tips
                                      description="業務時間内で手動登録可能な時間の合計"
                                      className=""
                                      icon={false}
                                    >
                                      <>
                                        <div
                                          className="work_time_label"
                                          style={{
                                            backgroundColor: "#00187d",
                                          }}
                                        >
                                          業務時間内の手動登録可能時間
                                        </div>
                                      </>
                                    </Tips>
                                    <div className="work_time_value min">
                                      {
                                        (task.taskLabeling.task_creatable_time) > 0 ? (
                                          <>
                                            {buildSecToTime(task.taskLabeling.task_creatable_time)}
                                          </>
                                        ) : (
                                          <>
                                            なし
                                          </>
                                        )
                                      }
                                    </div>
                                  </div>
                                </>
                              )
                            }
                          </div>
                        </div>
                        {
                          !!task.taskLabeling.base_work_start_time && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                userSelect: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => toggleDisplayBaseWorkTime(!isDisplayBaseWorkTime)}
                              role="none"
                            >
                              {buildCheckBox(isDisplayBaseWorkTime)}
                              標準勤務時間を表示する
                            </div>
                          )
                        }
                      </>
                    ) : (
                      <div />
                    )
                  }
                </>
              )
            }
          </div>
          <div className="labeling_header">
            {
              task.isLoading ? (
                <></>
              ) : (
                <>
                  {
                    ((isLocked && !task.taskLabeling?.not_working_ranges?.length)) ? (
                      <></>
                    ) : (
                      <div
                        style={{
                          border: "solid 1px #CCCCCC",
                          borderRadius: "4px",
                          backgroundColor: "#EEEEEE",
                          color: "#333333",
                          padding: "4px 16px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          width: "100%",
                        }}
                      >
                        <div>
                          {task.taskLabeling?.not_working_ranges?.length ? "範囲指定された業務外作業があります" : "作業データを範囲指定でまとめて業務外作業に変更できます"}
                        </div>
                        {
                          isLabeledInNotWorkingRange && (
                            <div
                              style={{
                                color: "#FF0000",
                              }}
                            >
                              仕分け済み作業データが含まれています
                            </div>
                          )
                        }
                        <button
                          type="button"
                          style={{
                            border: "solid 1px #CCCCCC",
                            borderRadius: "4px",
                            padding: "4px 8px",
                            fontSize: "10px",
                            backgroundColor: "#FFFFFF",
                            color: "#333333",
                          }}
                          onClick={openNotWorkingModal}
                        >
                          {task.taskLabeling?.not_working_ranges?.length ? "確認する" : "業務外範囲を登録する"}
                        </button>
                        {
                          !isLocked && !!task.taskLabeling?.not_working_ranges?.length && (
                            <button
                              type="button"
                              style={{
                                border: "solid 1px #CCCCCC",
                                borderRadius: "4px",
                                padding: "4px 8px",
                                fontSize: "10px",
                                backgroundColor: "#FFFFFF",
                                color: "#333333",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                              onClick={() => updateRange([])}
                            >
                              <FontAwesomeIcon
                                icon={['fas', 'trash-alt']}
                                style={{
                                  color: "#FF0000",
                                  cursor: "pointer",
                                }}
                              />
                              業務外範囲を削除する
                            </button>
                          )
                        }
                      </div>
                    )
                  }
                </>
              )
            }
          </div>
          <div className="block-detail" style={{ position: "relative" }}>
            {
              task.isLoading ? (
                <LoadingSquare>
                  <>
                    業務仕分けデータを生成しています…
                  </>
                </LoadingSquare>
              ) : (
                <>
                  {
                    taskList.length ? (
                      <>
                        {
                          !isLocked && (
                            <>
                              <button
                                type="button"
                                style={{
                                  position: "absolute",
                                  top: "-28px",
                                  right: "0px",
                                  borderRadius: "4px",
                                  padding: "2px 8px",
                                  fontSize: "10px",
                                  backgroundColor: "#2073b7",
                                  color: "#FFFFFF",
                                  display: "flex",
                                  gap: "2px",
                                }}
                                onClick={() => setIsOpenLabelingGuide(true)}
                              >
                                <FontAwesomeIcon icon={['far', 'hand-point-right']} />
                                仕分けしたい時の便利ショートカット
                              </button>
                              <div
                                style={{
                                  position: "absolute",
                                  top: "-12px",
                                  left: "-34px",
                                  fontSize: "18px",
                                  color: "#666666",
                                  cursor: "pointer",
                                  display: "flex",
                                  flexFlow: "column",
                                }}
                                onClick={clickTaskAllRow}
                                role="none"
                              >
                                <div
                                  style={{
                                    fontSize: "8px",
                                  }}
                                >
                                  全選択
                                </div>
                                {
                                  taskList.length === checkedTaskIds.length ? (
                                    <>
                                      <FontAwesomeIcon icon={['far', 'check-square']} style={{ color: "#228b22" }} />
                                    </>
                                  ) : (
                                    <>
                                      <FontAwesomeIcon icon={['far', 'square']} />
                                    </>
                                  )
                                }
                              </div>
                            </>
                          )
                        }
                        <div className="labeling_legend_area">
                          <div className="timeline_legend">
                            <div
                              className="legend_color"
                              style={{
                                backgroundColor: "#b39b2d",
                              }}
                            />
                            <div className="legend_text">
                              未仕分け
                            </div>
                          </div>
                          <div className="timeline_legend">
                            <div
                              className="legend_color"
                              style={{
                                backgroundColor: "#008800",
                              }}
                            />
                            <div className="legend_text">
                              仕分け済み
                            </div>
                          </div>
                        </div>
                        {labelBlock(isDisplayBaseWorkTime, true)}
                        {displayTaskList}
                        {
                          selectTask ? (
                            <AddLabelBigModal
                              taskStatus={selectTask}
                              labelGroupOriginList={login.permissions?.high_volume ? [] : task.taskLabeling?.label_groups || []}
                              callbackLabels={(taskIds, labelGroup, labels) => addLabel(taskIds, labelGroup, labels[0])}
                              closeCallback={() => setSelectTask(undefined)}
                              currentMemberId={Number(id) || commonPart.current_member_id || 0}
                              taskDetails={taskList.filter((v) => selectTask.ids.includes(v.task_id))}
                              date={date}
                            />
                          ) : (
                            <></>
                          )
                        }
                      </>
                    ) : (
                      <div className="timeline_no_data">
                        データがありません
                      </div>
                    )
                  }
                  {labelBlock()}
                  {
                    isDisplayPanel ? (
                      <>
                        <div className="fixed_box">
                          <div
                            onClick={() => setIsDisplayPanel(!isDisplayPanel)}
                            role="none"
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "20px",
                              color: "#666666",
                              fontSize: "20px",
                              cursor: "pointer",
                            }}
                          >
                            <FontAwesomeIcon icon={['fas', 'times']} />
                          </div>
                          {
                            !!selectPeriod.length && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: "90%",
                                  right: "10%",
                                  backgroundColor: "#FFFFFF",
                                  padding: "16px",
                                  border: "solid 1px #06a2a2",
                                  borderRadius: "4px",
                                  display: "flex",
                                  flexFlow: "column",
                                  gap: "4px",
                                }}
                              >
                                <div
                                  onClick={() => setSelectPeriod([])}
                                  role="none"
                                  style={{
                                    position: "absolute",
                                    top: "2px",
                                    right: "5px",
                                    color: "#666666",
                                    cursor: "pointer",
                                  }}
                                >
                                  <FontAwesomeIcon icon={['fas', 'times']} />
                                </div>
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontSize: "14px",
                                    color: "#06a2a2",
                                  }}
                                >
                                  選択範囲内の仕分けできる時間
                                </div>
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                    color: "#666666",
                                  }}
                                >
                                  {buildDisplayTime(inRecodeTotalTime)}
                                </div>
                                {
                                  inRecodeTotalTime > 60 && (
                                    <div
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {
                                        isLocked ? (
                                          <>
                                            <span style={{ color: "#FF0000" }}>
                                              {`「${statusText(task.taskLabeling?.approval_status || "")}」のため、作業データを作成できません`}
                                            </span>
                                          </>
                                        ) : (
                                          <>
                                            <button
                                              type="button"
                                              style={{
                                                border: "solid 1px #999999",
                                                borderRadius: "20px",
                                                padding: "4px 16px",
                                                color: "#666666",
                                              }}
                                              onClick={createRangeTask}
                                            >
                                              作業データを作成
                                            </button>
                                          </>
                                        )
                                      }
                                    </div>
                                  )
                                }
                              </div>
                            )
                          }
                          <div
                            style={{
                              padding: "0 34px 0 48px",
                              display: isDisplayPanel ? "block" : "none",
                            }}
                          >
                            {labelBlock()}
                            {
                              (
                                (login.current_member_id === member_id) || (login.display_create_manual_task)
                              ) && (
                                <div className="timeline untracked">
                                  <div className="timeline_row">
                                    {
                                      isLoadingManualTask && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            width: "100%",
                                            height: "100%",
                                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                                            zIndex: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#FFFFFF",
                                            fontSize: "20px",
                                          }}
                                        >
                                          <FontAwesomeIcon icon={['fas', 'spinner']} spin />
                                        </div>
                                      )
                                    }
                                    {rulerBlock()}
                                    {displayUntrackedTask}
                                    {
                                      Array(48).fill(null).map((_v, i) => (
                                        <div
                                          key={uniqueId()}
                                          style={{
                                            position: "absolute",
                                            top: "2px",
                                            height: "34px",
                                            width: `${((5 / 6) * 100) / 48}%`,
                                            left: `${((1 / 6) * 100) + ((((5 / 6) * 100) / 48) * i)}%`,
                                            zIndex: 1,
                                            cursor: "pointer",
                                            backgroundColor: selectPeriod.includes(i) ? "rgba(132, 187, 255, 0.5)" : "transparent",
                                          }}
                                          onMouseDown={() => {
                                            clickPeriod(i)
                                            setDragPeriod(true)
                                          }}
                                          onMouseUp={() => setDragPeriod(false)}
                                          onMouseEnter={() => dragPeriod && clickPeriod(i)}
                                          role="none"
                                        />
                                      ))
                                    }
                                    <div className="timeline_detail">
                                      <div className="announce_wrap">
                                        作業データの手動登録可能時間
                                        <button
                                          type="button"
                                          className="question"
                                          onClick={() => dispatch(updateTaskAnnounce(!current.taskAnnounce))}
                                        >
                                          <FontAwesomeIcon icon={['far', 'question-circle']} />
                                        </button>
                                        {
                                          current.taskAnnounce || (
                                            <div className="announce">
                                              <div>
                                                手動で作業データを登録可能な時間が表示されています。
                                              </div>
                                              <div>
                                                バーをクリックすると範囲を選択し、作業データを登録することができます。
                                              </div>
                                              <button
                                                type="button"
                                                className="close"
                                                onClick={() => dispatch(updateTaskAnnounce(!current.taskAnnounce))}
                                              >
                                                <FontAwesomeIcon icon={['fas', 'times']} />
                                              </button>
                                            </div>
                                          )
                                        }
                                      </div>
                                    </div>
                                    <div className="timeline_legend_area">
                                      <div className="timeline_legend">
                                        <div
                                          className="legend_color"
                                          style={{
                                            backgroundColor: "#e9d7ff",
                                          }}
                                        />
                                        <div className="legend_text">
                                          PC未使用
                                        </div>
                                      </div>
                                      <div className="timeline_legend">
                                        <div
                                          className="legend_color"
                                          style={{
                                            backgroundColor: "#b4e5e2",
                                          }}
                                        />
                                        <div className="legend_text">
                                          仕分け対象外アプリ
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                            <div className="timeline calendar">
                              <div className="timeline_row">
                                {rulerBlock()}
                                {displayCalendarSchedules}
                                <div className="timeline_detail">
                                  <div>
                                    <Tips
                                      description="連携されたカレンダーの予定が表示されます。%br%バーにカーソルをのせると予定に関わる作業データがハイライトされます。"
                                      className="normal"
                                    >
                                      <>
                                        カレンダーの予定
                                      </>
                                    </Tips>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div
                          onClick={() => setIsDisplayPanel(!isDisplayPanel)}
                          role="none"
                          className="fixed_box_min"
                        >
                          <FontAwesomeIcon icon={['fas', 'angle-up']} style={{ fontSize: "20px" }} />
                          {login.current_member_id === member_id && ("手動で作業データを登録する / ")}
                          カレンダーの予定を見る
                        </div>
                      </>
                    )
                  }
                  {
                    checkedTaskIds.length ? (
                      <>
                        <div className="fixed_box" style={{ zIndex: 1000000 }}>
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              color: "#666666",
                              fontSize: "20px",
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => setCheckedTaskIds([])}
                            >
                              <FontAwesomeIcon icon={['fas', 'times']} />
                            </button>
                          </div>
                          <div
                            style={{
                              marginBottom: "8px",
                            }}
                          >
                            {`${checkedTaskIds.length}件の作業データが選択されています。`}
                          </div>
                          <div
                            style={{
                              marginBottom: "8px",
                              border: "solid 1px #CCCCCC",
                              padding: "8px",
                              overflowY: "auto",
                              maxHeight: "100px",
                              minHeight: "100px",
                              backgroundColor: "#FFFFFF",
                            }}
                          >
                            {
                              taskList.filter((v) => checkedTaskIds.includes(v.task_id)).map((v) => (
                                <div
                                  key={uniqueId()}
                                  className="select_task"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    marginBottom: "8px",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        color: v.icon_color || (v.type !== "ActiveTask" && v.task_name ? "#008800" : "#FF0000"),
                                      }}
                                    >
                                      {
                                        v.icon ? (
                                          <FontAwesomeIcon
                                            icon={[v.icon.split(" ")[0] as IconPrefix, v.icon.split(" ")[1] as IconName]}
                                            fixedWidth
                                          />
                                        ) : (
                                          <FontAwesomeIcon
                                            icon={v.task_name ? ["fas", "check-circle"] : ["fas", "exclamation-triangle"]}
                                            fixedWidth
                                          />
                                        )
                                      }
                                    </div>
                                    {
                                      !!v.service_name && (
                                        <div>
                                          {v.service_name}
                                        </div>
                                      )
                                    }
                                    <div>
                                      {v.task_name}
                                    </div>
                                  </div>
                                  <>
                                    {
                                      // eslint-disable-next-line max-len
                                      ((!v.label) || (v.label && !v.label.disabled && (v.label.status === "suggestion" || v.label.status === "repeat_suggestion"))) && (
                                        <div className="label_wrapper no_label">
                                          <div className="label">
                                            未仕分け
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      v.label && v.label.status === "auto" && (
                                        <div className="label_wrapper auto">
                                          <FontAwesomeIcon icon={['fas', 'robot']} className="fa-fw c_icon" />
                                          <div className="label">
                                            {`${v.label.label_group_name}:${v.label.label_name || ""}`}
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      v.label && v.label.status === "repeat" && (
                                        <div className="label_wrapper persistence">
                                          <FontAwesomeIcon icon={['fas', 'history']} className="fa-fw c_icon" />
                                          <div className="label">
                                            {`${v.label.label_group_name}:${v.label.label_name || ""}`}
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      // eslint-disable-next-line max-len
                                      v.label
                                      && v.label.label_group_id > RESERVED_LABEL_GROUP_ID
                                      && (v.label.status === "manual" || v.label.status === "suggestion_accepted")
                                      && (
                                        <div className="label_wrapper">
                                          <FontAwesomeIcon icon={['fas', 'hand-point-right']} className="fa-fw c_icon" />
                                          <div className="label">
                                            {`${v.label.label_group_name}:${v.label.label_name || ""}`}
                                          </div>
                                        </div>
                                      )
                                    }
                                    {
                                      v.label && v.label.label_group_id <= RESERVED_LABEL_GROUP_ID && (
                                        <div className={`label_wrapper ${reservedLabelClass(v.label.label_group_id)}`}>
                                          <FontAwesomeIcon
                                            icon={['fas', reservedLabelIcon(v.label.label_group_id) as IconName]}
                                            className="fa-fw c_icon"
                                          />
                                          <div className="label">
                                            {`${v.label.label_group_name}`}
                                          </div>
                                        </div>
                                      )
                                    }
                                  </>
                                </div>
                              ))
                            }
                          </div>
                          {
                            taskList.filter((v) => (
                              checkedTaskIds.includes(v.task_id)
                              && v.label?.status
                              && v.label.status !== "suggestion"
                              && v.label.status !== "repeat_suggestion"
                            )).length ? (
                              <>
                                <div
                                  style={{
                                    marginBottom: "8px",
                                    color: "#FF0000",
                                  }}
                                >
                                  仕分け済み作業データが選択されています。操作にご注意ください。
                                </div>
                              </>
                              ) : (
                                <></>
                              )
                          }
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => setCheckedTaskIds([])}
                              style={{
                                borderRadius: "4px",
                                padding: "6px 8px",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                cursor: "pointer",
                                position: "relative",
                                fontSize: "10px",
                                backgroundColor: "#999999",
                                color: "#ffffff",
                                pointerEvents: "initial",
                              }}
                            >
                              すべてのチェックを外す
                            </button>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => multiDelLabel(checkedTaskIds)}
                                style={{
                                  borderRadius: "4px",
                                  padding: "6px 8px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  cursor: "pointer",
                                  position: "relative",
                                  fontSize: "10px",
                                  backgroundColor: "#ffffff",
                                  color: "#E44242",
                                  border: "solid 1px #E44242",
                                  pointerEvents: "initial",
                                }}
                              >
                                <FontAwesomeIcon icon={['fas', 'times']} />
                                まとめて業務仕分けを解除する
                              </button>
                              <button
                                type="button"
                                onClick={(e) => openAddLabelMultiTaskModule(e, checkedTaskIds)}
                                style={{
                                  borderRadius: "4px",
                                  padding: "6px 8px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  cursor: "pointer",
                                  position: "relative",
                                  fontSize: "10px",
                                  backgroundColor: "#E44242",
                                  color: "#ffffff",
                                  pointerEvents: "initial",
                                }}
                              >
                                <FontAwesomeIcon icon={['fas', 'tags']} rotation={90} />
                                まとめて業務仕分け
                              </button>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )
                  }
                </>
              )
            }
          </div>
        </div>
      </section>
      <UseLabelModal
        list={task.taskLabeling?.target_services || []}
        closeCallback={() => setIsDisplayUseLabel(false)}
        isDisplay={isDisplayUseLabel}
      />
      {/* 確認モーダル */}
      <PersistenceConfirmationModal
        confirmationModalState={confirmationModalState}
        closeCallback={closeConfirmationModal}
      />
      <CutTaskModal
        type={type}
        timeList={periodList}
        originTask={cutTaskOrigin}
        cutCallback={(name, labelId, timeline, timeList, isNotBelong, originTaskId, postType, afterFunc) => addTask(
          name, labelId, timeline, timeList, isNotBelong, originTaskId, postType, afterFunc,
        )}
        isDisplay={isDisplayCutModal}
        closeCallback={closeCutTaskModal}
        currentMemberId={Number(id) || commonPart.current_member_id || 0}
        date={date}
        overwrite={login.permissions?.task_overwrite_break_time || false}
      />
      <ApprovedModal
        detail={detailData}
        closeCallback={() => setIsOpenDetailModal(false)}
        updateCallback={(param, callback) => updateApproval(param, callback)}
        isDisplay={isOpenDetailModal}
        isApplication={isSelf}
        displayLink={false}
        isDisplayWorkTime={!isSelf}
      />
      <ExclusionAutoLabelingConfirmationModal
        task={exclusionTask}
        isDisplay={isDisplayExclusionModal}
        updateCallback={(targetId, targetType) => updateExclusion(targetId, targetType)}
        closeCallback={closeExclusionAutoLabelingTaskModal}
      />
      <NotWorkingModal
        timeList={task.taskNotWorkingRange?.not_working_ranges || []}
        originTask={task.taskNotWorkingRange?.task_details || []}
        addCallback={(range, afterFunc) => updateRange(range, afterFunc)}
        isDisplay={!isLocked && isOpenNotWorkingModal}
        closeCallback={closeNotWorkingModal}
        date={date}
        loading={isLoadingNotWorkingModal}
      />
      <NotWorkingModalForDisplay
        timeList={task.taskNotWorkingRange?.not_working_ranges || []}
        originTask={task.taskNotWorkingRange?.task_details || []}
        isDisplay={isLocked && isOpenNotWorkingModal}
        closeCallback={closeNotWorkingModal}
        date={date}
        loading={isLoadingNotWorkingModal}
      />
      <Modal
        show={isOpenLabelingGuide}
        wrapperClass="effort_label"
        modalSize="large"
        closeCallback={() => setIsOpenLabelingGuide(false)}
        closeable
      >
        <>
          <div
            style={{
              marginBottom: "24px",
              fontSize: "20px",
              textAlign: "center",
            }}
          >
            仕分けしたい時の便利ショートカット
          </div>
          <div
            style={{
              display: "flex",
              flexFlow: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                border: "solid 1px #CCCCCC",
                borderRadius: "4px",
                padding: "8px",
                display: "flex",
                flexFlow: "column",
                gap: "8px",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                }}
              >
                作業データを「Ctrlキー(MacはCommandキー) + クリック」で選択できます
              </div>
              <div>
                <img
                  src="/static/images/task/image_9.png"
                  alt="作業データを「Ctrlキー(MacはCommandキー) + クリック」で選択できます"
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            </div>
            <div
              style={{
                border: "solid 1px #CCCCCC",
                borderRadius: "4px",
                padding: "8px",
                display: "flex",
                flexFlow: "column",
                gap: "8px",
              }}
            >
              <div
                style={{
                  fontWeight: "bold",
                }}
              >
                作業データを「Shiftキー + ドラッグ」でまとめて選択できます
              </div>
              <div>
                <img
                  src="/static/images/task/image_10.png"
                  alt="作業データを「Shiftキー + ドラッグ」でまとめて選択できます"
                  style={{
                    width: "100%",
                  }}
                />
              </div>
            </div>
          </div>
        </>
      </Modal>
    </section>
  )
}

export default Index
